import { AbstractControl, Validators } from "@angular/forms";
import { ValidationPatterns } from "@bbwt/modules/validation";
import { CoreRole, IRole } from "@main/roles";

export function checkGenericLoginRole(userName: AbstractControl, roles?: IRole[]) {
    const isGenericLogin = roles?.some(r => r.name === CoreRole.GenericLogin || r.name === CoreRole.GenericPatientLogin);
    if (isGenericLogin) {
        userName.addValidators([Validators.required, Validators.pattern(ValidationPatterns.username), Validators.maxLength(256)]);
    } else {
        userName.clearValidators();
    }

    userName.updateValueAndValidity({ onlySelf: true });
    return isGenericLogin;
}


export function checkGenericPatientLoginRole(userName: AbstractControl, roles?: IRole[]) {
    return roles?.some(r =>  r.name === CoreRole.GenericPatientLogin);
}

export function checkGenericLoginOrClinicalSafetyOfficerRole(userName: AbstractControl, roles?: IRole[]) {
    const isGenericLogin = roles?.some(r => r.name === CoreRole.GenericLogin || r.name === CoreRole.GenericPatientLogin);
    const clinicalSafetyOfficer=  roles?.some(r =>  r.name === CoreRole.ClinicalSafetyOfficer);

    if (isGenericLogin || clinicalSafetyOfficer) {
        userName.addValidators([Validators.required, Validators.pattern(ValidationPatterns.username), Validators.maxLength(256)]);
    } else {
        userName.clearValidators();
    }
    userName.updateValueAndValidity({ onlySelf: true });

    return [isGenericLogin, clinicalSafetyOfficer];
}